/* eslint-disable */
import TourCriteriaObjectValue from '@/js/common/Domain/ObjectValue/TourCriteria';
import { propsDecorator, extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import toRouterHydrator from '@/js/common/Domain/Hydrator/toRouter';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import tourCriteriaHotelService from '@/js/common/Domain/Service/tourCriteriaHotel';
import moment from 'moment';
import 'moment/locale/ru';
import ecommerceService from '@/js/common/Domain/Service/ecommerce';
import foundSimilarTourAndSlice from '@/js/common/Domain/Service/foundSimilarTourAndSlice';
import { filterToProductType } from '@ve/services/productTypeConverter';
import HotelPageFilterCriteria from '@/js/common/Domain/Model/hotelPage/HotelPageFilterCriteria';
import filterTourProductsByAdditionalFilters from '@/js/common/Service/hotelPage/filterTourProductsByAdditionalFilters';
import groupProductsByCriterias from '@/js/common/Domain/Service/groupProductsByCriterias';
import HotelPageModel from '@/js/common/Domain/Service/hotelSearch/HotelPageModel';
import TourProductsSortedHotelRepository from '../components/TourProductsSortedHotelRepository';

export default function tourSearchModel(tourProductsCollection) {
    const currentTourCriteria = new TourCriteriaObjectValue();

    @propsDecorator({
        defaults: {
            searchData: currentTourCriteria,
            filterCriteria: null,
            beforeToursLoading: true,
            sortStrategy: (document.location.hash.indexOf('identity=') === -1) ? 'priceUp' : 'identity',

            selectedSortValue: 0,
            numOfTourPerPage: 5,
            operatorsCount: 0,
            roomTypesCount: 0,
            airLinesCount: 0,
            operatorsTitle: '',
            roomTypesTitle: '',
            airLinesTitle: '',

            dropDown: false, //TODO: remove - lagacy
            roomTypesDropDown: false, //TODO: remuve - legacy
            airLinesDropDown: false, //TODO: remuve - legacy

            selectedIdentity: null,
            hot: false,
            loadingState: 'loading', //"loading", "asyncLoading", "finished"
            loadingInProgress: false,
            syncTourProducts: null,
            asyncTourProducts: null,
            dateFilteredTourProducts: null,
            // filteredTourProducts: [],
            filteredTourProductsWithSimilarTours: [],
            pageNumber: 0,
            subscribeState: '0',
            thEmail: '',
            hotelInfo: null,
            datesTabsList: [],
            datesTabsListLength: 0,
            minPriceCount: 0,
            desiredCollectionLength: 0,
            autoSelectedTabDateMode: 1,
            searchStartCounter: 0,
        },
    })

    @extendDecorator({
        computeds: {
            lessPlaces() {
                const syncTourProducts = this.get('syncTourProducts');
                return (syncTourProducts && syncTourProducts.at(0) && syncTourProducts.at(0).get('product').get('lessPlaces'));
            },
            subscribe: {
                deps: ['subscribeState'],
                get(subscribeState) {
                    return subscribeState;
                },
                set(value) {
                    return {subscribeState: value};
                },
            },
            syncTourProductsWithIsExclusive: {
                deps: ['syncTourProducts'],
                get(syncTourProducts) {
                    if (!syncTourProducts?.length) return [];
                    const syncTourProductsSorted = new TourProductsSortedHotelRepository(syncTourProducts.models, this);
                    const groupedSyncTourProducts = groupProductsByCriterias(syncTourProductsSorted);
                    this.calculateIsExclusive(groupedSyncTourProducts, syncTourProducts || []);
                    return syncTourProductsSorted;
                },
            },
            /**
             * filterTourProductsByAdditionalFilters - пустышка, ничего не фильтрует
             */
            filteredTourProductsAll: {
                deps: ['filterCriteria', 'syncTourProductsWithIsExclusive'],
                get(filterCriteria, syncTourProductsWithIsExclusive) {
                    if (!syncTourProductsWithIsExclusive?.length) {
                        return [];
                    }

                    const filterTourProductsByAdditionalFiltersData = filterTourProductsByAdditionalFilters(filterCriteria, syncTourProductsWithIsExclusive.models);
                    return new TourProductsSortedHotelRepository(filterTourProductsByAdditionalFiltersData, this);
                },
            },

            filteredTourProducts: {
                deps: ['filteredTourProductsAll'],
                get(filteredTourProductsAll) {
                    const date = this.get('filterCriteria').get('selectedTabDate');
                    const filteredTourProductsByDate = this.filterTourProductsByDate(filteredTourProductsAll, date);

                    return new TourProductsSortedHotelRepository(filteredTourProductsByDate, this);
                },
            },

            similarHotelsUrl() {
                const tourCriteria = this.get('searchData');
                const params = toRouterHydrator(tourCriteria);

                delete (params.priceFrom);
                delete (params.priceTo);
                delete (params.hotels);
                delete (params.meal);

                return `/search#?${$.param(params)}`;
            },
            nothingFoundDescription() {
                const searchData = this.get('searchData');
                const fromCity = searchData.get('departureCity') !== null ? searchData.get('departureCity').get('name') : '';
                const toCountry = searchData.get('countries') !== null ? searchData.get('countries').at(0).get('name') : '';
                const resorts = searchData.get('resorts') !== null ? searchData.get('resorts').pluck('name') : '';
                const hotels = searchData.get('hotels') !== null ? searchData.get('hotels').pluck('name') : '';
                const nightsFrom = searchData.get('nightRange') !== null ? searchData.get('nightRange').get('from') : '';
                const nightsTo = searchData.get('nightRange') !== null ? searchData.get('nightRange').get('to') : '';
                const dateFrom = searchData.get('checkInDateRange') !== null ? $.datepicker.formatDate('dd.mm', searchData.get('checkInDateRange').get('from')) : '';
                const dateTo = searchData.get('checkInDateRange') !== null ? $.datepicker.formatDate('dd.mm', searchData.get('checkInDateRange').get('to')) : '';
                const adults = searchData.get('touristGroup') !== null ? searchData.get('touristGroup').get('adults') : '';
                const kids = searchData.get('touristGroup') !== null ? searchData.get('touristGroup').get('kids') : '';
                const infants = searchData.get('touristGroup') !== null ? searchData.get('touristGroup').get('infants') : '';
                const hotelClass = searchData.get('hotelCategories') !== null ? searchData.get('hotelCategories').pluck('name') : '';
                const meal = searchData.get('meals') !== null ? searchData.get('meals').pluck('code') : '';
                let comments = '';

                if (fromCity && toCountry) {
                    comments += `Из: ${fromCity} в ${toCountry}\n`;
                }

                if (resorts.length) {
                    comments += `Курорты: ${resorts.join(', ')}\n`;
                }

                if (dateFrom) {
                    comments += `Дата вылета: c ${dateFrom} по ${dateTo}\n`;
                }

                if (nightsFrom && nightsTo) {
                    comments += `Длительность: ${nightsFrom}${nightsFrom == nightsTo ? '' : ` - ${nightsTo}`} ночей\n`;
                }

                if (hotels.length) {
                    comments += `Отель: ${hotels.join(', ')}\n`;
                }

                if (hotelClass) {
                    comments += `Класс отеля: ${hotelClass && hotelClass.length ? hotelClass.join(', ') : 'Любой'}\n`;
                }

                if (adults) {
                    comments += `Кто едет: ${adults} взрослых`;

                    if (kids != 0) {
                        comments += ` и ${kids} детей`;
                    }
                    if (infants != 0) {
                        comments += ` и ${infants} младенцев`;
                    }

                    comments += '\n';
                }

                if (meal) {
                    comments += `Питание: ${meal && meal.length ? meal.join(', ') : 'Любое'}\n`;
                }

                comments += '\n';

                return comments;
            },
            isRegion() {
                const departureCity = this.get('searchData').get('departureCity');

                return !!(departureCity && departureCity.get('id') > 2);
            },
            fromMoscowUrl() {
                const searchData = this.get('searchData');
                let params;
                let url = '';

                if (searchData) {
                    params = toRouterHotelHydrator({
                        tourCriteria: searchData,
                        hot: false,
                        identity: null,
                        sid: searchSessionService.getSearchId(),
                        hsid: searchSessionService.getHotelSearchId(),
                    });
                    params.fromCity = 2;
                    url = `#?${$.param(params)}`;
                }

                return url;
            },
            hotTour() {
                return false;
            },
            minPriceTourProduct: {
                deps: ['filteredTourProducts'],
                get(tourProducts) {
                    if (!tourProducts?.length) {
                        return null;
                    }

                    return tourProducts.min((tourProduct) => tourProduct.get('product')?.get('priceWithOilTax') || tourProduct.get('product').get('price'));
                },
            },
            minPrice: {
                deps: ['minPriceTourProduct'],
                get(minPriceTourProduct) {
                    if (minPriceTourProduct) {
                        return minPriceTourProduct.get('product')?.get('priceWithOilTax')
                            || minPriceTourProduct.get('product').get('price');
                    }
                    return null;
                },
            },
            minPricePerPerson() {
                const tourProducts = this.get('filteredTourProducts');
                let touristGroup;
                let numOfTourists;
                let minPrice;

                if (tourProducts && tourProducts.length) {
                    const firstProduct = tourProducts.at(0);
                    const product = firstProduct.get('product');
                    touristGroup = product.get('touristGroup');
                    numOfTourists = parseInt(touristGroup.adults, 10) + parseInt(touristGroup.kids, 10) + (touristGroup.infants ? parseInt(touristGroup.infants, 10) : 0);
                    minPrice = this.get('minPrice');

                    return Math.round(minPrice / numOfTourists);
                }
                return false;
            },
            minPricePerPersonOutput() {
                return this.get('minPricePerPerson') ? this.get('minPricePerPerson').formatNumber() : false;
            },
            pageIncAvaliable() {
                const numOfTourPerPage = this.get('numOfTourPerPage');
                const pageNumber = this.get('pageNumber');
                const tourProducts = this.get('filteredTourProductsWithSimilarTours');
                let maxPages;

                if (tourProducts && tourProducts.length) {
                    maxPages = Math.ceil(tourProducts.length / numOfTourPerPage);
                    return pageNumber < maxPages;
                }
                return false;
            },
            filteredTourProductLength() {
                return this.get('filteredTourProducts').length;
            },
            toursLost() {
                return this.get('filteredTourProductsWithSimilarTours').length - this.get('pageNumber') * this.get('numOfTourPerPage');
            },
            toutLostInCollection() {
                return this.get('toursLost') > this.get('numOfTourPerPage') ? this.get('numOfTourPerPage') : this.get('toursLost');
            },
            toutLostInCollectionBool() {
                return this.get('toursLost') > this.get('numOfTourPerPage');
            },
            fromCityLabel() {
                if (this.get('searchData').get('departureCity') !== null) {
                    return this.get('searchData').get('departureCity').get('name');
                }
                return false;
            },
            toCountryFlag() {
                if (this.get('searchData').get('countries') !== null) {
                    return `flagIco flag_${this.get('searchData').get('countries').at(0).get('id')}`;
                }
                return false;
            },
            toCountryLabel() {
                if (this.get('searchData').get('countries') !== null) {
                    return this.get('searchData').get('countries').pluck('name').slice(0, 3)
                        .join(', ');
                }
                return false;
            },
            resortsLabel() {
                if (this.get('searchData').get('resorts') !== null && this.get('searchData').get('resorts').length) {
                    return this.get('searchData').get('resorts').pluck('name').slice(0, 4)
                        .join(', ');
                }
                return false;
            },
            dateLabel() {
                let from;
                let
                    to;
                if (this.get('searchData').get('checkInDateRange') !== null) {
                    from = this.get('searchData').get('checkInDateRange').get('from');
                    to = this.get('searchData').get('checkInDateRange').get('to');
                    return from.getTime() != to.getTime() ? `${$.datepicker.formatDate('dd.mm', from)} &mdash; ${$.datepicker.formatDate('dd.mm', to)}` : $.datepicker.formatDate('dd.mm', from);
                }
                return false;
            },
            nightsLabelOriginal() {
                let from;
                let
                    to;
                if (this.get('searchData').get('nightRange') !== null) {
                    from = this.get('searchData').get('nightRange').get('from');
                    to = this.get('searchData').get('nightRange').get('to');

                    return from != to ? (`от ${from} до ${to} ноч${to.wordEnding('ь;и;ей')}`) : (`${to} ноч${to.wordEnding('ь;и;ей')}`);
                }
                return false;
            },
            nightsLabel() {
                let from;
                let to;
                const nightsChanged = _.contains(tourCriteriaHotelService.getTourCriteriaChangedFields(), 'nightRange');

                if (this.get('searchData').get('nightRange') !== null && nightsChanged) {
                    from = this.get('searchData').get('nightRange').get('from');
                    to = this.get('searchData').get('nightRange').get('to');
                    return from != to ? (`от ${from} до ${to} ноч${to.wordEnding('ь;и;ей')}`) : (`${to} ноч${to.wordEnding('ь;и;ей')}`);
                }
                return false;
            },
            budgetLabel() {
                let from;
                let to;
                const budgetChanged = _.contains(tourCriteriaHotelService.getTourCriteriaChangedFields(), 'priceRange');

                if (this.get('searchData').get('priceRange') !== null && budgetChanged) {
                    from = this.get('searchData').get('priceRange').get('from');
                    to = this.get('searchData').get('priceRange').get('to');
                    return from != to ? (`${from.formatNumber()}<span class="rubl">a</span> - ${to.formatNumber()} <span class="rubl">a</span>`) : (`${from.formatNumber()}<span class="rubl">a</span>`);
                }
                return false;
            },
            hotelCategoriesLabel() {
                if (this.get('searchData').get('hotelCategories') !== null && this.get('searchData').get('hotelCategories').length) {
                    return this.get('searchData').get('hotelCategories').pluck('name').join(', ');
                }
                return false;
            },
            postFiltersSelected() {
                const filterCriteria = this.get('filterCriteria');
                return filterCriteria.get('operators')?.length || filterCriteria.get('isExclusive');
            },
            preFiltersSelected() {
                return this.get('warrantedFilterSelected') || this.get('mealFilterSelected');
            },
            warrantedFilterSelected() {
                return !!this.get('searchData').get('warranted');
            },
            mealFilterSelected() {
                return !!(this.get('searchData').get('meals')?.length);
            },
            mealFilterChanged() {
                return !!(this.get('searchData').get('meals') && this.get('searchData').get('meals').length);
            },
            mealsLabel() {
                if (this.get('searchData').get('meals') !== null) {
                    const meals = this.get('searchData').get('meals').pluck('code').join(', ');

                    return meals;
                }
                return false;
            },
            mealsLabelSmart() {
                const label = [];
                if (this.get('searchData').get('meals') !== null) {
                    const mealsCount = this.get('searchData').get('meals').length;
                    this.get('searchData').get('meals').each((meal) => {
                        if (mealsCount == 1) {
                            label.push(`<span title="${meal.get('name')}">${meal.get('code')}<span class="mealsHelpBlock"> - ${meal.get('name')}</span></span>`);
                        } else {
                            label.push(`<span title="${meal.get('name')}">${meal.get('code')}</span>`);
                        }
                    });
                    return label.join(', ');
                }
                return false;
            },
            hotelsLabel() {
                if (this.get('searchData').get('hotels') !== null) {
                    if (this.get('searchData').get('hotels').length) {
                        return this.get('searchData').get('hotels').pluck('name').slice(0, 2)
                            .join(', ');
                    }
                    return false;
                }
                return false;
            },
            adults() {
                if (this.get('searchData').get('touristGroup') !== null) {
                    return this.get('searchData').get('touristGroup').get('adults');
                }
                return false;
            },
            kids() {
                if (this.get('searchData').get('touristGroup') !== null) {
                    return this.get('searchData').get('touristGroup').get('kids');
                }
                return false;
            },
            infants() {
                let infants;
                const touristGroup = this.get('searchData').get('touristGroup');
                if (touristGroup !== null) {
                    infants = touristGroup.get('infants');
                    return infants || 0;
                }
                return false;
            },
            adultsLabel() {
                if (this.get('searchData').get('touristGroup') !== null) {
                    return this.get('searchData').get('touristGroup').get('adults');
                }
                return false;
            },
            kidsLabel() {
                const kids = this.get('kids');
                return kids || '-';
            },
            infantLabel() {
                const infants = this.get('infants');
                return infants || '-';
            },

            numOfTourProductsFound() {
                const tourProducts = this.get('syncTourProducts');
                if (tourProducts !== null && tourProducts.length > 0) {
                    return tourProducts.length;
                }
                return false;
            },
            numOfTourProductsFiltered() {
                if (this.get('filteredTourProducts') !== null) {
                    return this.get('filteredTourProducts').length;
                }
                return false;
            },
            minPriceSyncTourProduct: {
                deps: ['syncTourProducts', 'filterCriteria', 'filteredTourProducts'],
                get(tourProducts, filterCriteria) {
                    if (!tourProducts?.length) {
                        return false;
                    }

                    const selectedProductType = filterCriteria.get('productType');
                    const filteredProducts = this.filterTourProductsByProductTypeWithTourPriority(tourProducts.models, selectedProductType);

                    const products = filteredProducts?.length
                        ? filteredProducts
                        : tourProducts;

                    const minPriceProduct = _.min(products.models, (tourProduct) => tourProduct?.get('product')?.get('priceWithOilTax')
                        ?? tourProduct?.get('product')?.get('price'));

                    return minPriceProduct === Infinity
                        ? false
                        : minPriceProduct;
                },
            },
            minPriceSyncTourProducts: {
                deps: ['minPriceSyncTourProduct'],
                get(minPriceSyncTourProduct) {
                    if (!minPriceSyncTourProduct) {
                        return false;
                    }

                    return minPriceSyncTourProduct?.get('product')?.get('priceWithOilTax')
                        ?? minPriceSyncTourProduct?.get('product')?.get('price');
                },
            },
            minPriceSyncTourProductsOilTax: {
                deps: ['minPriceSyncTourProduct'],
                get(minPriceSyncTourProduct) {
                    if (!minPriceSyncTourProduct) {
                        return false;
                    }

                    return minPriceSyncTourProduct?.get('product')?.get('oilTax')
                        ?? minPriceSyncTourProduct?.get('product')?.get('price');
                },
            },
            minPriceAsyncTourProduct() {
                const tourProducts = this.get('asyncTourProducts');
                let minPrice = Infinity;
                let minPriceTourProduct;

                if (tourProducts && tourProducts.length) {
                    tourProducts.each((tourProduct) => {
                        const price = tourProduct.get('tour').get('price');
                        if (price < minPrice) {
                            minPrice = price;
                            minPriceTourProduct = tourProduct;
                        }
                    });
                    return minPriceTourProduct;
                }
                return false;
            },
            newResultLowerPriceTourProductsFound() {
                let priceDifference;
                const minPriceSyncTourProduct = this.get('minPriceSyncTourProduct');
                const minPriceAsyncTourProduct = this.get('minPriceAsyncTourProduct');
                const minPriceSync = minPriceSyncTourProduct
                    ? minPriceSyncTourProduct.get('product')?.get('price')
                    : null;
                const minPriceAsync = minPriceAsyncTourProduct
                    ? minPriceAsyncTourProduct.get('product')?.get('price')
                    : null;

                if (minPriceSync > 0 && minPriceAsync > 0 && minPriceAsync <= minPriceSync - 1000) {
                    priceDifference = minPriceSync - minPriceAsync;
                    return priceDifference;
                }
                return false;
            },
            additionalTourProductsFound() {
                let newTours;
                const syncTourProducts = this.get('syncTourProducts');
                const asyncTourProducts = this.get('asyncTourProducts');

                if (syncTourProducts !== null && asyncTourProducts !== null) {
                    newTours = asyncTourProducts.length - syncTourProducts.length;
                    if (newTours > 0) {
                        return newTours;
                    }
                    return false;
                }
                return false;
            },
            departureCityName() {
                let departureCityName = '';
                if (this.get('searchData').get('departureCity') && this.get('searchData').get('departureCity').get('name')) {
                    departureCityName = this.get('searchData').get('departureCity').get('name');
                }
                return departureCityName;
            },
            hideMinPriceTooltips: {
                deps: ['minPriceCount'],
                get(minPriceCount) {
                    return minPriceCount > 1;
                },
            },
        },
    })
    class TourSearchModel extends HotelPageModel {
        filndMinPriceProduct(tourProducts, type) {
            if (!tourProducts?.length) {
                return false;
            }

            const filteredProducts = this.filterTourProductsByProductTypeWithTourPriority(tourProducts.models, type);

            if (!filteredProducts.length) {
                return false;
            }

            const minPriceProduct = _.min(filteredProducts.models, (tourProduct) => tourProduct?.get('product')?.get('priceWithOilTax')
                ?? tourProduct?.get('product')?.get('price'));

            return minPriceProduct === Infinity
                ? false
                : minPriceProduct;
        }

        /**
         * null object pattern одиннаковый интерфейс с travelata
         * */
        calculateIsExclusive() {}

        filteredTourProductsChanged() {
            const filteredTourProductsWithSimilarTours = foundSimilarTourAndSlice(this.get('filteredTourProducts'));
            this.set({filteredTourProductsWithSimilarTours});
            tourProductsCollection?.reset();

            this.set('pageNumber', 1, {silent: true});
            this.incCollection();
        }

        incCollection() {
            const numOfTourPerPage = this.get('numOfTourPerPage');
            const pageNumber = this.get('pageNumber');
            const tourProducts = this.get('filteredTourProductsWithSimilarTours');
            let addTourProducts = [];

            if (tourProducts && tourProducts.length) {
                addTourProducts = tourProducts.models.slice((pageNumber - 1) * numOfTourPerPage, numOfTourPerPage * pageNumber);
                tourProductsCollection.add(addTourProducts);
                this.callECommerce(addTourProducts);
            }
        }

        filterTourProductsByDate(tourProducts, selectedTabDate) {
            if (!tourProducts?.length) return [];
            return tourProducts.filter((tourProduct) => {
                const date = this.getFromDate(tourProduct);
                return moment(date).format('YYYY-MM-DD') === selectedTabDate;
            });
        }

        changedSyncTourProducts() {
            let cheapestModel;
            const self = this;
            const tourProducts = this.get('syncTourProducts');
            let currentTourCriteria = null;

            // this.generateDatesTabs();

            if (tourProducts !== null && tourProducts.length > 0 && this.view !== undefined) {
                currentTourCriteria = this.view.searchFormModel.getTourCriteria();
            }

            if (currentTourCriteria && currentTourCriteria.get('countries') && currentTourCriteria.get('resorts') && tourProducts !== null && tourProducts.length > 0) {
                cheapestModel = tourProducts.min(element => element.get('tour').get('price'));

                const departureCity = currentTourCriteria.get('departureCity').get('name');
                const country = currentTourCriteria.get('countries').at(0).get('name');
                const resorts = currentTourCriteria.get('resorts');
                const resortModel = resorts && resorts.at(0) || null;
                const resortName = resortModel && resortModel.get('name') || '';
                const nbra = parseInt(cheapestModel.get('tour').get('touristGroup').adults, 10);
                const nbrc = cheapestModel.get('tour').get('touristGroup').kids;
                const nbri = cheapestModel.get('tour').get('touristGroup').infants || 0;
                const checkin_date = moment(currentTourCriteria.get('checkInDateRange').get('from')).format('YYYY-MM-DD');
                const checkout_date = moment(currentTourCriteria.get('checkInDateRange').get('to')).format('YYYY-MM-DD');

                const price = cheapestModel.get('finalPrice');
                if (typeof (window.APRT_SEND) !== 'undefined') {
                    window.APRT_SEND({
                        pageType: 2,
                        searchTickets: {
                            type: 'hotel',
                            class: window.appConfig.hotelInfo.class,
                            from: departureCity,
                            country,
                            dest: resortName,
                            dateFrom: checkin_date,
                            dateTill: checkout_date,
                            count: nbra,
                            countChildren: nbrc,
                            countBaby: nbri,
                        },
                        currentProduct: {
                            id: window.appConfig.hotelInfo.id,
                            name: window.appConfig.hotelInfo.name,
                            price,
                        },
                    });
                }


                if (window.setGlobalWindowCritea) {
                    setGlobalWindowCritea([
                        {
                            event: 'viewItem',
                            item: window.appConfig.hotelInfo.id,
                        },
                        {
                            event: 'viewSearch',
                            din: checkin_date,
                            dout: checkout_date,
                            nbra,
                            nbrc,
                            nbri,
                            nbrr: '',
                        },
                    ]);
                }
            }
        }

        filterTourProductsByProductTypeWithTourPriority(tourProducts, selectedProductType) {
            return new Backbone.Collection(selectedProductType === 'all' ? tourProducts.models : tourProducts.filter((product) => product.get('type') === filterToProductType(selectedProductType)));
        }

        getFromDate(model) {
            if ((model.get('type') === 'TourProduct' || model.get('type') === 'RailwayTourProduct')
                && model.get('product').get('routes').length && model.get('product').get('routes')[0].there?.legs?.[0].departureDate
            ) {
                return model.get('product').get('routes')[0].there.legs[0].departureDate.substr(0, 10); //to cut time
            }
            return model.get('product').get('checkInDate');
        }

        initModelEvents() {
            this.on('change:pageNumber', $.proxy(this.incCollection, this));
            this.on('change:syncTourProducts', $.proxy(this.changedSyncTourProducts, this));
            this.on('change:filteredTourProducts', $.proxy(this.filteredTourProductsChanged, this));

            this.get('filterCriteria').on('change:selectedTabDate', () => this.recompute('filteredTourProducts'));
            this.get('filterCriteria').on('change:productType change:operators change:isExclusive', () => this.recompute('filteredTourProductsAll'));
        }

        callECommerce(newTourProducts) {
            ecommerceService.hotelImpressions({
                collection: tourProductsCollection,
                hotelInfo: window.appConfig.hotelInfo,
                tourProducts: newTourProducts,
                category: 'tour',
                pageType: 'tour',
                departureCityName: this.get('departureCityName'),
            });
        }

        initialize() {
            this.set('filterCriteria', new HotelPageFilterCriteria());
            this.initModelEvents();
        }
    }

    return new TourSearchModel();
}